// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeMask = (mask: string): any =>
  (mask != null &&
    mask.replace(/[.]/, '').replace('-', '').replace(/[.]/, '').replace(/\s/g, '').replace('(', '').replace(')', '')) ||
  mask ||
  ''
